import IngredientsPage from "~/components/_/ingredients/details.vue";

var ingredientsApp = new Vue({
  el: "#pages-ingredients-ingredients-content",
  components: {
    IngredientsPage
  }
});
